// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx"}[chunkId] || chunkId) + "-" + {"279":"3d582325ec5627cd04db","415":"8118f6d114b585991084","454":"a1247d612300c4c85cc7"}[chunkId] + ".js";
};